var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsequence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6395 5.85046C22.6622 4.60292 24.5706 4.60292 25.5932 5.85046C27.2168 7.83098 29.8448 8.68489 32.3224 8.03691C33.8831 7.62874 35.427 8.75045 35.521 10.3608C35.6704 12.9174 37.2946 15.153 39.6799 16.085C41.1824 16.6721 41.7721 18.4871 40.9017 19.8452C39.5198 22.0013 39.5198 24.7646 40.9017 26.9207C41.7721 28.2788 41.1824 30.0938 39.6799 30.6809C37.2946 31.613 35.6704 33.8486 35.521 36.4051C35.427 38.0155 33.8831 39.1372 32.3224 38.729C29.8448 38.0811 27.2168 38.935 25.5932 40.9155C24.5706 42.163 22.6622 42.163 21.6395 40.9155C20.016 38.935 17.3879 38.0811 14.9103 38.729C13.3497 39.1372 11.8058 38.0155 11.7117 36.4051C11.5624 33.8486 9.93812 31.613 7.55284 30.6809L6.82493 32.5437L7.55284 30.6809C6.05034 30.0938 5.46062 28.2788 6.33108 26.9207C7.71296 24.7646 7.71296 22.0013 6.33108 19.8452C5.46062 18.4871 6.05034 16.6721 7.55284 16.085C9.93812 15.153 11.5624 12.9174 11.7117 10.3608C11.8058 8.75045 13.3497 7.62874 14.9103 8.03691C17.3879 8.68489 20.016 7.83098 21.6395 5.85046Z",
    stroke: "#596F93",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0702 28.8677L21.7524 28.855L21.1367 14.1871L26.0931 13.1455L25.0702 28.8677Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.331 30.3113H21.5487L21.9767 33.6205H24.9224L25.331 30.3113Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsequence);
export default __webpack_public_path__ + "static/media/consequence.8dc3ec4408817424ca6140a17c700bca.svg";
export { ForwardRef as ReactComponent };